import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface BestellPdfVorschauZeile {
    artikel: string;
    menge: string;
    inhalt?: string;
}

export interface BestellPdfVorschauBlatt {
    lieferant: string;
    positionen: BestellPdfVorschauZeile[];
}

export interface BestellPdfVorschauData {
    artikel?: string;
    menge?: string;
    lieferant?: string;
    blaetter?: BestellPdfVorschauBlatt[];
}

@Component({
    selector: 'kiene-bestell-pdf-vorschau-dialog',
    templateUrl: './bestell-pdf-vorschau-dialog.component.html',
    styleUrls: ['./bestell-pdf-vorschau-dialog.component.scss'],
})
export class BestellPdfVorschauDialogComponent {
    blaetter: BestellPdfVorschauBlatt[];

    constructor(
        public dialogRef: MatDialogRef<BestellPdfVorschauDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: BestellPdfVorschauData,
    ) {
        if (data?.blaetter?.length) {
            this.blaetter = data.blaetter;
            return;
        }
        this.blaetter = [
            {
                lieferant: data?.lieferant || '',
                positionen: [{ artikel: data?.artikel || '', menge: data?.menge || '' }],
            },
        ];
    }

    hatInhalt(blatt: BestellPdfVorschauBlatt): boolean {
        return (blatt.positionen || []).some(zeile => !!zeile.inhalt);
    }
}
